module.exports = __webpack_public_path__ + "static/star-28648bdad07256d84109adb0b3999eda.jpg";